export enum UserRole {
  SUPERADMIN = 'superadmin',
  USER = 'user',
}
// export type TUserRole = (typeof UserRole)[keyof typeof UserRole]

export enum MemberRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
}
// export type TMemberRole = (typeof MemberRole)[keyof typeof MemberRole]
